import './Phone.scss';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Button from '../../common/Button/Button';
import Text from '../../common/Text/Text';
import { ChangeEvent, useState } from 'react';
import Input from '../../common/Input/Input';
import useBooking from '../../hooks/useBooking/useBooking';
import { useNavigate } from 'react-router';

const Phone = () => {
  const [error, setError] = useState('');
  const { phoneNumber, setPhoneNumber } = useBooking();
  const navigate = useNavigate();

  const handlePhoneChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPhoneNumber(e.target.value.replace(/[^+\d\s]/g, ''));
    setError('');
  };

  const isValidPhone = (string: string) => {
    const stripWhiteSpace = string?.replace(/\s/g, '');
    return /^((\+44)|(0)) ?\d{4} ?\d{6}$/.test(stripWhiteSpace);
  };

  const handleContinue = () => {
    if (isValidPhone(phoneNumber)) {
      navigate('/destination') as void;
    } else {
      setError('You must enter a valid phone number');
    }
  };

  return (
    <div className="phone">
      <img src={logo} className="logo" />
      <div className="content">
        <Text type="header">What&apos;s your phone number?</Text>
        <Input
          inputId="phone"
          onChange={handlePhoneChange}
          value={phoneNumber}
          inputType="tel"
          error={error}
        />
        <Button
          buttonStyleType="primary"
          label="Continue"
          handleClick={handleContinue}
          customStyling={{ width: '100%' }}
          disabled={!phoneNumber}
        />
      </div>
    </div>
  );
};

export default Phone;
